import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "faq"
    }}>{`FAQ`}</h2>
    <p>{`Feel free to add your FAQs. You can add it by making Pull Request to the
`}<a parentName="p" {...{
        "href": "https://github.com/Cezerin3/Documentation"
      }}>{`https://github.com/Cezerin3/Documentation`}</a></p>
    <h3 {...{
      "id": "cors-allow-cross-origin-error-how-to-fix"
    }}>{`CORS (Allow-Cross-Origin) Error. How to fix?!`}</h3>
    <p>{`You need to change all configs and replace all localhost with your ip number or
domain name.`}</p>
    <p>{`How it's work.`}</p>
    <p>{`Check file: /cezerin2/src/index.js This code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// CORS headers
var allowedOrigins = security.getAccessControlAllowOrigin()
var origin = req.headers.origin
if (allowedOrigins === "*") {
  res.setHeader("Access-Control-Allow-Origin", allowedOrigins)
} else {
  if (allowedOrigins.indexOf(origin) > -1) {
    res.setHeader("Access-Control-Allow-Origin", origin)
  }
}
`}</code></pre>
    <p>{`And this file: /cezerin2/src/lib/security.js`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const getAccessControlAllowOrigin = () => {
  return [settings.storeBaseUrl, settings.adminBaseURL] || "*"
}
`}</code></pre>
    <p>{`storeBaseUrl and adminBaseURL settings located in your config
/cezerin2/config/server.js`}</p>
    <h3 {...{
      "id": "cant-build-cezerin2-store-app-how-to-fix"
    }}>{`Can't build cezerin2-store app, how to fix?`}</h3>
    <p>{`Try to install node-sass before cezerin2-store dependencies.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`sudo npm i --unsafe-perm node-sass
`}</code></pre>
    <p>{`Then download cezerin2-store and try to install:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`npm i && npm run build
`}</code></pre>
    <h3 {...{
      "id": "cant-build-cezerin2-app-api-on-ubuntu-how-to-fix"
    }}>{`Can't build cezerin2 app (api) on ubuntu, how to fix?`}</h3>
    <p>{`If you have this error:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`Failed to execute '/usr/bin/node /usr/lib/node_modules/npm/node_modules/node-gyp/bin/node-gyp.js build --fallback-to-build --module=/root/cezerin2/node_modules/bcrypt/lib/binding/bcrypt_lib.node --module_name=bcrypt_lib --module_path=/root/cezerin2/node_modules/bcrypt/lib/binding --napi_version=4 --node_abi_napi=napi --napi_build_version=0 --node_napi_label=node-v72' (1)
npm WARN optional SKIPPING OPTIONAL DEPENDENCY: fsevents@1.2.7 (node_modules/fsevents):
npm WARN notsup SKIPPING OPTIONAL DEPENDENCY: Unsupported platform for fsevents@1.2.7: wanted {"os":"darwin","arch":"any"} (current: {"os":"linux","arch":"x64"})
`}</code></pre>
    <p>{`Possible problem in bcrypt dependency.`}</p>
    <p>{`Try to install cezerin2 app like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`npm install --save bcrypt
npm audit fix
`}</code></pre>
    <h3 {...{
      "id": "npm-run-build-command-returns-error-137-how-to-fix"
    }}>{`"npm run build" command returns "Error 137", how to fix?`}</h3>
    <p>{`Increase RAM size (free memory) on your machine.`}</p>
    <p>{`You can see free memory by this console command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`free - m
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      